"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniButtonImage = exports.MiniButton = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _facepaint = _interopRequireDefault(require("facepaint"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mq = (0, _facepaint["default"])(['@media screen and (min-width: 375px)']);

var getButtonColor = function getButtonColor(theme, colorKey) {
  var defaultColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'transparent';

  if (colorKey) {
    var themeColor = theme && theme.getColor && theme.getColor(colorKey);
    return themeColor || defaultColor;
  }

  return defaultColor;
};

var getSize = function getSize(size) {
  var normalizedSize = Array.isArray(size) ? size : [size];
  return mq({
    width: normalizedSize,
    height: normalizedSize
  });
};

var MiniButton = (0, _styledBase["default"])("button", {
  target: "e1ikbe2a0",
  label: "MiniButton"
})(function (_ref) {
  var size = _ref.size;
  return getSize(size);
}, ";border-radius:50%;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      theme = _ref2.theme;
  return getButtonColor(theme, backgroundColor);
}, ";border-color:", function (_ref3) {
  var borderColor = _ref3.borderColor,
      theme = _ref3.theme;
  return getButtonColor(theme, borderColor);
}, ";border-width:", function (_ref4) {
  var borderWidth = _ref4.borderWidth;
  return borderWidth;
}, ";padding:", function (_ref5) {
  var padding = _ref5.padding;
  return padding;
}, ";outline:none;overflow:hidden;transition:opacity 0.3s;cursor:pointer;display:flex;align-items:center;justify-content:center;color:", function (_ref6) {
  var color = _ref6.color,
      theme = _ref6.theme;
  return getButtonColor(theme, color, 'inherit');
}, ";&:active{opacity:0.8;}");
exports.MiniButton = MiniButton;
var MiniButtonImage = (0, _styledBase["default"])("img", {
  target: "e1ikbe2a1",
  label: "MiniButtonImage"
})({
  name: "wgmksf",
  styles: "height:100%;width:100%;object-fit:contain;flex-shrink:0;"
});
exports.MiniButtonImage = MiniButtonImage;

//# sourceMappingURL=CircleButton.styles.js.map